export const MAX_ITEMS_PER_CATEGORY = 20;

/** Bound tenant formatter, from useRegionalFormat() (QL-108). */
export type FormatNumberFn = (
  value: number | null | undefined,
  options?: { minimumFractionDigits?: number; maximumFractionDigits?: number },
) => string;
export type ParseNumberFn = (input: string | null | undefined) => number | null;

export function formatCurrency(value: number, currency: string, fmt: FormatNumberFn): string {
  return `${currency} ${fmt(value, { maximumFractionDigits: 0 })}`;
}

export function formatPercent(value: number, fmt: FormatNumberFn): string {
  return `${fmt(value * 100, { minimumFractionDigits: 1, maximumFractionDigits: 1 })}%`;
}

/** QL-414 — debt to income is a multiple of annual income ("2,4x"), as the PDF prints it. */
export function formatMultiple(value: number, fmt: FormatNumberFn): string {
  return `${fmt(value, { minimumFractionDigits: 1, maximumFractionDigits: 1 })}x`;
}

/** QL-368 — an absent amount renders as an empty input; `0` renders as "0". */
export function formatNumberInput(value: number | undefined, fmt: FormatNumberFn): string {
  if (value === undefined) return "";
  return fmt(value, { maximumFractionDigits: 0 });
}

/**
 * Integer-only inputs: rounds like the previous parseInt-based parser.
 * QL-368 — an empty or unparsable input is `undefined` (nothing entered), so
 * clearing a field is distinguishable from typing 0.
 */
export function parseNumberInput(value: string, parse: ParseNumberFn): number | undefined {
  const parsed = parse(value);
  return parsed == null ? undefined : Math.round(parsed);
}
